function get_c_s() {
    "do conv";
    let o = ["Arial", "Arial Black", "Bahnschrift", "Calibri", "Cambria", "Cambria Math", "Candara", "Comic Sans MS", "Consolas", "Constantia", "Corbel", "Courier New", "Ebrima", "Franklin Gothic Medium", "Gabriola", "Gadugi", "Georgia", "HoloLens MDL2 Assets", "Impact", "Ink Free", "Javanese Text", "Leelawadee UI", "Lucida Console", "Lucida Sans Unicode", "Malgun Gothic", "Marlett", "Microsoft Himalaya", "Microsoft JhengHei", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Sans Serif", "Microsoft Tai Le", "Microsoft YaHei", "Microsoft Yi Baiti", "MingLiU-ExtB", "Mongolian Baiti", "MS Gothic", "MV Boli", "Myanmar Text", "Nirmala UI", "Palatino Linotype", "Segoe MDL2 Assets", "Segoe Print", "Segoe Script", "Segoe UI", "Segoe UI Historic", "Segoe UI Emoji", "Segoe UI Symbol", "SimSun", "Sitka", "Sylfaen", "Symbol", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana", "Webdings", "Wingdings", "Yu Gothic", "Al Bayan", "Al Nile", "Al Tarikh", "American Typewriter", "American Typewriter Condensed", "Andale Mono", "Apple Braille", "Apple Braille Outline 6 Dot", "Apple Braille Outline 8 Dot", "Apple Braille Pinpoint 6 Dot", "Apple Braille Pinpoint 8 Dot", "Apple Chancery", "Apple Color Emoji", "Apple SD Gothic Neo", "Apple SD Gothic Neo Extra", "Apple Symbols", "AppleGothic", "AppleMyungjo", "Arial", "Arial Black", "Arial Hebrew", "Arial Hebrew Scholar", "Arial Narrow", "Arial Rounded MT", "Arial Unicode MS", "Avenir Black", "Avenir Book", "Avenir", "Avenir Next", "Avenir Next Condensed", "Avenir Roman", "Ayuthaya", "Baghdad", "Bangla MN", "Bangla Sangam MN", "Baskerville", "Beirut", "Big Caslon", "Bodoni 72", "Bodoni 72 Book", "Bodoni 72 Oldstyle", "Bodoni 72 Oldstyle Book", "Bodoni 72 Smallcaps Book", "Bodoni Ornaments", "Bradley Hand", "Brush Script MT", "Chalkboard", "Chalkboard SE", "Chalkduster", "Charter Black", "Charter", "Charter Roman", "Cochin", "Copperplate", "Corsiva Hebrew", "Courier", "Courier New", "DIN Alternate", "DIN Condensed", "Damascus", "Damascus Semi", "DecoType Naskh", "Devanagari MT", "Devanagari Sangam MN", "Didot", "Diwan Kufi", "Diwan Thuluth", "Euphemia UCAS", "Farah", "Farisi", "Futura", "Futura Condensed Extra", "Futura Condensed", "GB18030 Bitmap", "Galvji", "Geeza Pro", "Geneva", "Georgia", "Gill Sans", "Gujarati MT", "Gujarati Sangam MN", "Gurmukhi MN", "Gurmukhi MT", "Gurmukhi Sangam MN", "Heiti SC", "Heiti TC", "Helvetica", "Helvetica Neue", "Helvetica Neue Condensed Black", "Helvetica Neue Condensed", "Herculanum", "Hiragino Maru Gothic ProN W4", "Hiragino Mincho ProN W3", "Hiragino Mincho ProN W6", "Hiragino Sans GB W3", "Hiragino Sans GB W6", "Hiragino Sans W0", "Hiragino Sans W1", "Hiragino Sans W2", "Hiragino Sans W3", "Hiragino Sans W4", "Hiragino Sans W5", "Hiragino Sans W6", "Hiragino Sans W7", "Hiragino Sans W8", "Hiragino Sans W9", "Hoefler Text", "Hoefler Text Black", "Hoefler Text Ornaments", "ITF Devanagari", "ITF Devanagari Book", "ITF Devanagari Marathi", "ITF Devanagari Marathi Book", "Impact", "InaiMathi", "Kailasa", "Kannada MN", "Kannada Sangam MN", "Kefa", "Khmer MN", "Khmer Sangam MN", "Kohinoor Bangla", "Kohinoor Devanagari", "Kohinoor Gujarati", "Kohinoor Telugu", "Kokonor", "Krungthep", "KufiStandardGK", "Lao MN", "Lao Sangam MN", "Lucida Grande", "Luminari", "Malayalam MN", "Malayalam Sangam MN", "Marker Felt", "Marker Felt Wide", "Menlo", "Microsoft Sans Serif", "Mishafi Gold", "Mishafi", "Monaco", "Mshtakan", "MuktaMahee", "Muna Black", "Muna", "Myanmar MN", "Myanmar Sangam MN", "Nadeem", "New Peninim MT", "New Peninim MT Bold Inclined", "New Peninim MT Inclined", "Noteworthy", "Noto Nastaliq Urdu", "Noto Sans Javanese", "Noto Sans Kannada Black", "Noto Sans Kannada", "Noto Sans Kannada Extra", "Noto Sans Myanmar Black", "Noto Sans Myanmar", "Noto Sans Myanmar Extra", "Noto Sans Oriya", "Optima", "Oriya MN", "Oriya Sangam MN", "PT Mono", "PT Sans", "PT Sans Caption", "PT Sans Narrow", "PT Serif", "PT Serif Caption", "Palatino", "Papyrus", "Papyrus Condensed", "Phosphate Inline", "Phosphate Solid", "PingFang HK", "PingFang SC", "PingFang TC", "Plantagenet Cherokee", "Raanana", "Rockwell", "STIXGeneral-", "STIXIntegralsD-", "STIXIntegralsSm-", "STIXIntegralsUp-", "STIXIntegralsUpD-", "STIXIntegralsUpSm-", "STIXNonUnicode-", "STIXSizeFiveSym-", "STIXSizeFourSym-", "STIXSizeOneSym-", "STIXSizeThreeSym-", "STIXSizeTwoSym-", "STIXVariants-", "STSong", "Sana", "Sathu", "Savoye LET Plain:1.0", "Shree Devanagari 714", "SignPainter-HouseScript", "Silom", "Sinhala MN", "Sinhala Sangam MN", "Skia Black", "Skia Black Condensed", "Skia Black Extended", "Skia", "Skia Condensed", "Skia Extended", "Skia Light Condensed", "Skia Light Extended", "Snell Roundhand", "Snell Roundhand Black", "Songti SC Black", "Songti SC", "Songti TC", "Sukhumvit Set", "Sukhumvit Set Semi", "Sukhumvit Set Text", "Symbol", "Tahoma", "Tamil MN", "Tamil Sangam MN", "Telugu MN", "Telugu Sangam MN", "Thonburi", "Times", "Times New Roman", "Times Roman", "Trattatello", "Trebuchet MS", "Verdana", "Waseem", "Webdings", "Wingdings", "Wingdings 2", "Wingdings 3", "Zapf Dingbats", "Zapfino", "Droid Sans", "Droid Serif", "Droid Sans Mono", "times new", "goudy"];
    const l = new class {
        constructor() {
            this.text = "abcdefghijklmnopqrstuvwxyz0123456789",
                this.canvas = document.createElement("canvas"),
                this.context = this.canvas.getContext("2d"),
                this.baselineSize = this.getFontWidth(this.getFontName())
        }

        getFontName(e) {
            return e ? "72px '" + e + "', monospace" : "72px monospace"
        }

        getFontWidth(e) {
            return this.context.font = e,
                this.context.measureText(this.text).width
        }

        checkAndGetWidth(e) {
            const t = this.getFontWidth(this.getFontName(e));
            return t !== this.baselineSize ? t : null
        }
    };
    let c = "";
    o.forEach(e => {
        const t = l.checkAndGetWidth(e);
        t && (c += t.toString())
    }),
        l.canvas = null,
        l.context = null;
    let s = "";
    o.forEach(e => {
        s += function (e) {
            const t = document.body
                , a = document.createElement("span");
            a.style.fontSize = "72px",
                a.innerHTML = "Aa(!0@#[+/-])|ü₹▁₺ꜽ�₸׆ẞॿ",
                a.style.fontFamily = e,
                t.appendChild(a),
                a.getBoundingClientRect();
            const n = a.offsetWidth + "," + a.offsetHeight;
            return t.removeChild(a),
                n
        }(e)
    });
    return [c, s];
}

function get_fingerprint(ee) {
    function r(e, t) {
        var a = (65535 & e) + (65535 & t);
        return (e >> 16) + (t >> 16) + (a >> 16) << 16 | 65535 & a
    }

    function o(e, t, a, n, i, o) {
        return r((l = r(r(t, e), r(n, o))) << (c = i) | l >>> 32 - c, a);
        var l, c
    }

    function l(e, t, a, n, i, r, l) {
        return o(t & a | ~t & n, e, t, i, r, l)
    }

    function c(e, t, a, n, i, r, l) {
        return o(t & n | a & ~n, e, t, i, r, l)
    }

    function s(e, t, a, n, i, r, l) {
        return o(t ^ a ^ n, e, t, i, r, l)
    }

    function u(e, t, a, n, i, r, l) {
        return o(a ^ (t | ~n), e, t, i, r, l)
    }

    function d(e, t) {
        var a, n, i, o, d;
        e[t >> 5] |= 128 << t % 32,
            e[14 + (t + 64 >>> 9 << 4)] = t;
        var g = 1732584193
            , h = -271733879
            , m = -1732584194
            , f = 271733878;
        for (a = 0; a < e.length; a += 16)
            n = g,
                i = h,
                o = m,
                d = f,
                g = l(g, h, m, f, e[a], 7, -680876936),
                f = l(f, g, h, m, e[a + 1], 12, -389564586),
                m = l(m, f, g, h, e[a + 2], 17, 606105819),
                h = l(h, m, f, g, e[a + 3], 22, -1044525330),
                g = l(g, h, m, f, e[a + 4], 7, -176418897),
                f = l(f, g, h, m, e[a + 5], 12, 1200080426),
                m = l(m, f, g, h, e[a + 6], 17, -1473231341),
                h = l(h, m, f, g, e[a + 7], 22, -45705983),
                g = l(g, h, m, f, e[a + 8], 7, 1770035416),
                f = l(f, g, h, m, e[a + 9], 12, -1958414417),
                m = l(m, f, g, h, e[a + 10], 17, -42063),
                h = l(h, m, f, g, e[a + 11], 22, -1990404162),
                g = l(g, h, m, f, e[a + 12], 7, 1804603682),
                f = l(f, g, h, m, e[a + 13], 12, -40341101),
                m = l(m, f, g, h, e[a + 14], 17, -1502002290),
                g = c(g, h = l(h, m, f, g, e[a + 15], 22, 1236535329), m, f, e[a + 1], 5, -165796510),
                f = c(f, g, h, m, e[a + 6], 9, -1069501632),
                m = c(m, f, g, h, e[a + 11], 14, 643717713),
                h = c(h, m, f, g, e[a], 20, -373897302),
                g = c(g, h, m, f, e[a + 5], 5, -701558691),
                f = c(f, g, h, m, e[a + 10], 9, 38016083),
                m = c(m, f, g, h, e[a + 15], 14, -660478335),
                h = c(h, m, f, g, e[a + 4], 20, -405537848),
                g = c(g, h, m, f, e[a + 9], 5, 568446438),
                f = c(f, g, h, m, e[a + 14], 9, -1019803690),
                m = c(m, f, g, h, e[a + 3], 14, -187363961),
                h = c(h, m, f, g, e[a + 8], 20, 1163531501),
                g = c(g, h, m, f, e[a + 13], 5, -1444681467),
                f = c(f, g, h, m, e[a + 2], 9, -51403784),
                m = c(m, f, g, h, e[a + 7], 14, 1735328473),
                g = s(g, h = c(h, m, f, g, e[a + 12], 20, -1926607734), m, f, e[a + 5], 4, -378558),
                f = s(f, g, h, m, e[a + 8], 11, -2022574463),
                m = s(m, f, g, h, e[a + 11], 16, 1839030562),
                h = s(h, m, f, g, e[a + 14], 23, -35309556),
                g = s(g, h, m, f, e[a + 1], 4, -1530992060),
                f = s(f, g, h, m, e[a + 4], 11, 1272893353),
                m = s(m, f, g, h, e[a + 7], 16, -155497632),
                h = s(h, m, f, g, e[a + 10], 23, -1094730640),
                g = s(g, h, m, f, e[a + 13], 4, 681279174),
                f = s(f, g, h, m, e[a], 11, -358537222),
                m = s(m, f, g, h, e[a + 3], 16, -722521979),
                h = s(h, m, f, g, e[a + 6], 23, 76029189),
                g = s(g, h, m, f, e[a + 9], 4, -640364487),
                f = s(f, g, h, m, e[a + 12], 11, -421815835),
                m = s(m, f, g, h, e[a + 15], 16, 530742520),
                g = u(g, h = s(h, m, f, g, e[a + 2], 23, -995338651), m, f, e[a], 6, -198630844),
                f = u(f, g, h, m, e[a + 7], 10, 1126891415),
                m = u(m, f, g, h, e[a + 14], 15, -1416354905),
                h = u(h, m, f, g, e[a + 5], 21, -57434055),
                g = u(g, h, m, f, e[a + 12], 6, 1700485571),
                f = u(f, g, h, m, e[a + 3], 10, -1894986606),
                m = u(m, f, g, h, e[a + 10], 15, -1051523),
                h = u(h, m, f, g, e[a + 1], 21, -2054922799),
                g = u(g, h, m, f, e[a + 8], 6, 1873313359),
                f = u(f, g, h, m, e[a + 15], 10, -30611744),
                m = u(m, f, g, h, e[a + 6], 15, -1560198380),
                h = u(h, m, f, g, e[a + 13], 21, 1309151649),
                g = u(g, h, m, f, e[a + 4], 6, -145523070),
                f = u(f, g, h, m, e[a + 11], 10, -1120210379),
                m = u(m, f, g, h, e[a + 2], 15, 718787259),
                h = u(h, m, f, g, e[a + 9], 21, -343485551),
                g = r(g, n),
                h = r(h, i),
                m = r(m, o),
                f = r(f, d);
        return [g, h, m, f]
    }

    function g(e) {
        var t, a = "", n = 32 * e.length;
        for (t = 0; t < n; t += 8)
            a += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
        return a
    }

    function h(e) {
        var t, a = [];
        for (a[(e.length >> 2) - 1] = void 0,
                  t = 0; t < a.length; t += 1)
            a[t] = 0;
        var n = 8 * e.length;
        for (t = 0; t < n; t += 8)
            a[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
        return a
    }

    function m(e) {
        var t, a, n = "";
        for (a = 0; a < e.length; a += 1)
            t = e.charCodeAt(a),
                n += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t);
        return n
    }

    function f(e) {
        return unescape(encodeURIComponent(e))
    }

    function S(e) {
        return function (e) {
            return g(d(h(e), 8 * e.length))
        }(f(e))
    }

    function p(e, t) {
        return function (e, t) {
            var a, n, i = h(e), r = [], o = [];
            for (r[15] = o[15] = void 0,
                  i.length > 16 && (i = d(i, 8 * e.length)),
                      a = 0; a < 16; a += 1)
                r[a] = 909522486 ^ i[a],
                    o[a] = 1549556828 ^ i[a];
            return n = d(r.concat(h(t)), 512 + 8 * t.length),
                g(d(o.concat(n), 640))
        }(f(e), f(t))
    }

    function v(e, t, a) {
        return t ? a ? p(t, e) : m(p(t, e)) : a ? S(e) : m(S(e))
    }

    return v(ee);
}

function get_audio_fp(callback) {
    var n, o;
    (n = 4500,
        o = 5e3,
        new Promise((e, t) => {
                let a = {
                    audio: {
                        timeout: 1e3,
                        excludeIOS11: !0
                    }
                };
                var i = a.audio;
                if (i.excludeIOS11 && navigator.userAgent.match(/OS 11.+Version\/11.+Safari/))
                    return e(a.EXCLUDED);
                var r = window.OfflineAudioContext || window.webkitOfflineAudioContext;
                if (null == r)
                    return e(a.NOT_AVAILABLE);
                var l = new r(1, 44200, 44100)
                    , c = l.createOscillator();
                c.type = "triangle",
                    c.frequency.setValueAtTime(1e4, l.currentTime);
                var s = l.createDynamicsCompressor();
                [["threshold", -50], ["knee", 40], ["ratio", 12], ["reduction", -20], ["attack", 0], ["release", .25]].forEach((function (e) {
                        void 0 !== s[e[0]] && "function" == typeof s[e[0]].setValueAtTime && s[e[0]].setValueAtTime(e[1], l.currentTime)
                    }
                )),
                    c.connect(s),
                    s.connect(l.destination),
                    c.start(0),
                    l.startRendering();
                var u = setTimeout((function () {
                        return console.warn('Audio fingerprint timed out. Please report bug at https://github.com/Valve/fingerprintjs2 with your user agent: "' + navigator.userAgent + '".'),
                            l.oncomplete = function () {
                            }
                            ,
                            l = null,
                            e("audioTimeout")
                    }
                ), i.timeout);
                l.oncomplete = function (t) {
                    var a;
                    try {
                        clearTimeout(u),
                            console.log("fake", 44100 !== l.sampleRate, l.sampleRate),
                            a = t.renderedBuffer.getChannelData(0).slice(n, o).reduce((function (e, t) {
                                    return e + Math.abs(t)
                                }
                            ), 0).toString(),
                            c.disconnect(),
                            s.disconnect()
                    } catch (t) {
                        return void e(t)
                    }
                    e(a)
                }
            }
        ).then(e => ({
            hash: get_fingerprint(e + ""),
            rawData: e
        }))).then(e => {
        console.log("audio_fingerprint=", e.hash);
        callback(e.hash);
    }).catch(() => {
        console.log("audio_fingerprint", "失败");
        callback("audio_error");
    })
}

function get_canvas_fp(e) {
    e = e || {};
    var t = {}
        , a = document.createElement("canvas");
    a.width = 2e3,
        a.height = 200,
        a.style.display = "inline";
    var n = a.getContext("2d");
    return n.rect(0, 0, 10, 10),
        n.rect(2, 2, 6, 6),
        t.canvasWinding = !1 === n.isPointInPath(5, 5, "evenodd") ? "yes" : "no",
        n.textBaseline = "alphabetic",
        n.fillStyle = "#f60",
        n.fillRect(125, 1, 62, 20),
        n.fillStyle = "#069",
        e.dontUseFakeFontInCanvas ? n.font = "11pt Arial" : n.font = "11pt no-real-font-123",
        n.fillText("Cwm fjordbank glyphs vext quiz, 😃", 2, 15),
        n.fillStyle = "rgba(102, 204, 0, 0.2)",
        n.font = "18pt Arial",
        n.fillText("Cwm fjordbank glyphs vext quiz, 😃", 4, 45),
        n.globalCompositeOperation = "multiply",
        n.fillStyle = "rgb(255,0,255)",
        n.beginPath(),
        n.arc(50, 50, 50, 0, 2 * Math.PI, !0),
        n.closePath(),
        n.fill(),
        n.fillStyle = "rgb(0,255,255)",
        n.beginPath(),
        n.arc(100, 50, 50, 0, 2 * Math.PI, !0),
        n.closePath(),
        n.fill(),
        n.fillStyle = "rgb(255,255,0)",
        n.beginPath(),
        n.arc(75, 100, 50, 0, 2 * Math.PI, !0),
        n.closePath(),
        n.fill(),
        n.fillStyle = "rgb(255,0,255)",
        n.arc(75, 75, 75, 0, 2 * Math.PI, !0),
        n.arc(75, 75, 25, 0, 2 * Math.PI, !0),
        n.fill("evenodd"),
    a.toDataURL && (t.rawData = a.toDataURL(),
        t.hash = get_fingerprint(t.rawData)),
        t
}

function get_webgl_fp() {
    var e;
    if (!(e = function () {
        var e = document.createElement("canvas")
            , t = null;
        try {
            t = e.getContext("webgl") || e.getContext("experimental-webgl")
        } catch (e) {
        }
        return t || (t = null),
            t
    }()))
        return null;
    var t = []
        , a = e.createBuffer();
    e.bindBuffer(e.ARRAY_BUFFER, a);
    var n = new Float32Array([-.2, -.9, 0, .4, -.26, 0, 0, .732134444, 0]);
    e.bufferData(e.ARRAY_BUFFER, n, e.STATIC_DRAW),
        a.itemSize = 3,
        a.numItems = 3;
    var r = e.createProgram()
        , o = e.createShader(e.VERTEX_SHADER);
    e.shaderSource(o, "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}"),
        e.compileShader(o);
    var l = e.createShader(e.FRAGMENT_SHADER);
    e.shaderSource(l, "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}"),
        e.compileShader(l),
        e.attachShader(r, o),
        e.attachShader(r, l),
        e.linkProgram(r),
        e.useProgram(r),
        r.vertexPosAttrib = e.getAttribLocation(r, "attrVertex"),
        r.offsetUniform = e.getUniformLocation(r, "uniformOffset"),
        e.enableVertexAttribArray(r.vertexPosArray),
        e.vertexAttribPointer(r.vertexPosAttrib, a.itemSize, e.FLOAT, !1, 0, 0),
        e.uniform2f(r.offsetUniform, 1, 1),
        e.drawArrays(e.TRIANGLE_STRIP, 0, a.numItems);
    try {
        t.push(e.canvas.toDataURL())
    } catch (e) {
        console.log(e)
    }
    return {
        hash: get_fingerprint(t[0]),
        rawData: t[0]
    }
}


// 设备指纹1
export const fp1 = function() {
    var canvas_fp = get_canvas_fp().hash;
    var webgl_fp = get_webgl_fp().hash;
    var c_s = get_c_s();
    var canvas_font_fp = get_fingerprint(c_s[0]);
    var css_font_fp = get_fingerprint(c_s[1]);
    return new Promise(function(resolve) {
      get_audio_fp(function callback(audio_fp) {
        var fp_list = [canvas_fp, webgl_fp, canvas_font_fp, css_font_fp, audio_fp, "huaerxiela"];
        var device_fp = get_fingerprint(fp_list.join('|'));
          resolve(device_fp)
      })
    })

}
// 设备指纹2,用在safari下
export const fp2 = function() {
    var c_s = get_c_s();
    var canvas_font_fp = get_fingerprint(c_s[0]);
    var css_font_fp = get_fingerprint(c_s[1]);
    var device_fp2 = get_fingerprint([canvas_font_fp, css_font_fp].join('|'));
    return device_fp2
}
